export enum FieldConfirmationTypeEnums {
    Unknown = 0,
    Apply,
    Save,
    Update,
    Remove,
    /**
     * Filter hase no name set
     */
    AddName,
    ApplyWithoutSave,
    EmptyFilter,
    RemoveDefaultName,
    SpacesOnly,
    SpacesOnlyInName,
}
